import { styled } from "@linaria/react"
import { useMemo } from "react"


import { LineCharComponent } from "@/components/Diff/DiffLineChar.tsx"
import { Horizontal } from "@/components/Flex.ts"
import { CodeRenderingOptions, renderLineWithMarkers } from "@/lib/diff/codeRenderingCommon.ts"
import { getDiffLineMarkers } from "@/lib/diff/diffRenderingCommon.ts"
import * as textStyles from "@/styles/textStyles.ts"

import type { SyntaxMarkupTheme } from "@/components/Diff/diffColors.ts"
import type { DiffLineType, InlineDiffLine } from "@/lib/client/generated/TypeDefinitions.ts"
import type { Property } from "csstype"

export const LineContentComponent = ({ data, lineTheme, syntaxTheme }: {
  data: InlineDiffLine
  lineTheme: (lineType: DiffLineType | undefined | null) => Property.BackgroundColor
  syntaxTheme: SyntaxMarkupTheme
}) => {
  const { type } = data
  const markers = useMemo(() => getDiffLineMarkers(data), [data])
  const lineHtml = useMemo(() => renderLineWithMarkers({
    lineText: data.text,
    lineMarkers: markers,
    syntaxTheme: syntaxTheme,
    options: CodeRenderingOptions.DiffDefault,
  }), [data, markers, syntaxTheme])

  return (
    <Container backgroundColor={lineTheme(type)}>
      <LineCharComponent type={type} />
      <span dangerouslySetInnerHTML={{ __html: lineHtml }} />
    </Container>
  )
}


const Container = styled(Horizontal)<{ backgroundColor: Property.BackgroundColor }>`
  ${textStyles.monospaceFont};

  flex: 1 0 auto;

  background-color: ${props => props.backgroundColor};

  padding: 0 8px 0 12px;

  white-space: pre;
`